<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M15.2133 1.25H4.78456C2.83136 1.25 1.25 2.83156 1.25 4.785V15.2172C1.25 17.1684 2.83136 18.75 4.78456 18.75H15.2154C17.1664 18.75 18.75 17.1684 18.75 15.215V4.785C18.7478 2.83156 17.1664 1.25 15.2133 1.25Z"
            fill="url(#paint0_linear_1518_25)"
        />
        <path
            d="M9.92486 5.27072L10.2792 4.65822C10.4979 4.27541 10.9857 4.14634 11.3684 4.36509C11.7512 4.58384 11.8802 5.07166 11.6615 5.45447L8.24726 11.3651H10.7166C11.5172 11.3651 11.9655 12.3057 11.6178 12.9576H4.37806C3.93624 12.9576 3.58191 12.6032 3.58191 12.1613C3.58191 11.7195 3.93624 11.3651 4.37806 11.3651H6.40781L9.00623 6.86103L8.19477 5.45228C7.97605 5.06947 8.10509 4.58603 8.48786 4.36291C8.87062 4.14415 9.354 4.27322 9.5771 4.65603L9.92486 5.27072ZM6.854 13.7779L6.08847 15.1057C5.86975 15.4885 5.382 15.6176 4.99923 15.3989C4.61647 15.1801 4.48742 14.6923 4.70614 14.3095L5.27482 13.3251C5.91787 13.126 6.44061 13.2792 6.854 13.7779ZM13.4463 11.3695H15.5176C15.9594 11.3695 16.3138 11.7238 16.3138 12.1657C16.3138 12.6076 15.9594 12.962 15.5176 12.962H14.3671L15.1436 14.3095C15.3623 14.6923 15.2333 15.1757 14.8505 15.3989C14.4677 15.6176 13.9844 15.4885 13.7613 15.1057C12.4533 12.8373 11.4712 11.1398 10.8194 10.0088C10.1523 8.85822 10.6292 7.70322 11.0994 7.31166C11.6222 8.20853 12.403 9.5626 13.4463 11.3695Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1518_25"
                x1="9.99891"
                y1="1.25"
                x2="9.99891"
                y2="18.75"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0ED4FC" />
                <stop offset="1" stop-color="#0C57EF" />
            </linearGradient>
        </defs>
    </svg>
</template>
